import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { verifyHyperpayCheckoutPayment } from "../../api/endpoints/hyperpay/hayperpayEndpoints";
import { FullSpinner } from "../../components/LoadingSpinner";
import { t } from "i18next";
import PaymentModel from "../../api/models/PaymentModel";
import ContainerMd from "../../components/Layouts/ContainerMd";
import LogoWithLanguage from "../../components/logo-with-language/LogoWithLanguage";
import { useQueryParams } from "../../hooks/useQueryParams";

export default function PaymentStatusPage() {
  const { payment_intent_id } = useParams();
  const queryParams = useQueryParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const redirectUrl = queryParams.get("redirect_to") ?? "/";

  useEffect(() => {
    if (!!payment_intent_id) checkPaymentStatus();
  }, [payment_intent_id]);

  const checkPaymentStatus = async () => {
    setIsLoading(true);
    const response = await verifyHyperpayCheckoutPayment(payment_intent_id!);
    const payment: PaymentModel = PaymentModel.fromApiResponse(response.data);
    setIsSuccess(payment.isSuccessful);
    setIsLoading(false);
  };

  if (isLoading) return <FullSpinner size={50} />;

  if (isSuccess)
    return (
      <ContainerMd>
        <div className="w-full flex flex-col align-center h-screen">
          <LogoWithLanguage />
          <h1 className="text-3xl mt-[30%] mx-auto">
            {t("page.paymentStatus.paymentSuccess")}
          </h1>
          <a
            className="py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500 mt-10 mx-auto"
            href={redirectUrl}
          >
            {t("page.paymentStatus.continue")}
          </a>
        </div>
      </ContainerMd>
    );

  return (
    <ContainerMd>
      <div className="w-full flex flex-col align-center h-screen">
        <LogoWithLanguage />
        <h1 className="text-3xl mt-[30%] mx-auto">
          {t("page.paymentStatus.paymentFailed")}
        </h1>
        <a
          className="py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500 mt-10 mx-auto"
          href={redirectUrl}
        >
          {t("page.paymentStatus.continue")}
        </a>
      </div>
    </ContainerMd>
  );
}
